import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import PostAddIcon from "@material-ui/icons/PostAdd";
import "font-awesome/css/font-awesome.min.css";
import React, { useEffect, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { logoutUser } from "../actions/authActions";
import { getDocs, getDocsByOffice, getDocsReq } from "../actions/getDocs";
import { loadRoutes } from "../actions/loadRoutes";
import { resetDocForm } from "../actions/resetDocFom";
import socket from "../actions/socketIO";
import { IP } from "../config/IP";
import store from "../store/createStore";
import "./Dashboard.css";
import DocDraftTabs from "./DocDraft";
import DocProcessingScreen from "./DocProcessingScreen";
import Home from "./HomeCreateDoc";
import OrganisationChat from "./OrganisationChart";
import { LeftSideScreen } from "./SideScreen";
import PrimarySearchAppBar from "./TopToolBar";

//import HomeEditingDoc from "./HomeEditingDoc";

//https://codepen.io/themustafaomar/pen/jLMPKm
function Dashboard(props) {
	//console.log("IP.nodeServer=", IP.nodeServer + "api/getDocsAggregates");
	const notitifcationRef = useRef(null);
	const state = useSelector((state) => state);
	const history = useHistory();

	let totalDocs = 0;

	let totalUsers = 0;

	//start get docs

	{
	}

	//end of docs
	var buffer;
	let image;
	try {
		buffer = Buffer.from(store.getState().auth.user.image.data);
		image = "data:image/png;base64," + buffer.toString("base64");
	} catch (e) {}
	//document.getElementById("profilePicture").src ="data:image/png;base64," + buffer.toString("base64");
	const [showscreen, setShowscreen] = React.useState("");
	const [imageSrc, setImageSrc] = React.useState(image);
	let imageltvar;
	let usernameV;
	try {
		imageltvar = store
			.getState()
			.auth.user.allUser.find(
				(y) => y._id === store.getState().auth.user.usernameId
			).username;
		usernameV = store
			.getState()
			.auth.user.allUser.find(
				(y) => y._id === store.getState().auth.user.usernameId
			).name;
	} catch (e) {}

	const [imageAlt, setImageAlt] = React.useState(imageltvar);
	const [username, setUsername] = React.useState(usernameV);
	const [office_name, setOffice_name] = React.useState(imageltvar);
	const [totalDocsv, setTotalDocsv] = React.useState(imageltvar);
	const [totalUsersv, setTotalUsersv] = React.useState(0);

	const setnewProfilePicture = (value) => {
		if (value) {
			console.log("Dashboard setnewProfilePicture issued");
			var buffer = Buffer.from(store.getState().userStatus.image.data);

			setImageSrc("data:image/png;base64," + buffer.toString("base64"));
		}
	};

	const refresh = () => {
		try {
			if (state.docs.docs.data.docsAggregates !== null) {
				console.log("state.docs.docs.docs.data", state.docs.docs.data);
				totalDocs = 0;
				totalUsers = state.auth.user.allUser.length;
				setTotalUsersv(totalUsers);

				state.docs.docs.data.docsAggregates.map((x) => {
					totalDocs += x.count;
				});

				console.log("totalDocs in render=", totalDocs);
				setTotalDocsv(totalDocs);
			}
		} catch (e) {
			totalDocs = 0;

			console.error("unable to assign totalDocs");
		}
	};
	const handleModelClose = () => {
		//refresh();
		console.log("span.onclick  get props=", props);
		var modal = document.getElementById("myModal");

		modal.style.display = "none";
		var contents = document.querySelector("#contents");
		document
			.querySelector("#show-side-navigation1")
			.classList.toggle("show-side-nav");
		document
			.querySelector("#show-side-navigation1")
			.classList.add("show-side-nav");
		contents.classList.add("margin");
	};

	const handleClick = (e, office_id, office_name, isActing) => {
		try {
			var aside = document.querySelector(".side-nav");
			var contents = document.querySelector("#contents");
			aside.classList.add("show-side-nav");
			contents.classList.add("margin");
		} catch (e) {
			console.log("handleClick show-side-navigation1 hide error", e);
		}
		props.resetDocForm();
		setShowscreen(
			<Home
				docType={e.target.id}
				office_id={office_id}
				office_name={office_name}
				isActing={isActing}
			/>
		);
		console.log("handleClick e.target.rel =", office_id);

		console.log("button clicked");
		let inputs = {
			url: IP.nodeServer + "api/routesRules",
			method: "POST",
			data: [{ name: "Doc_type_id", value: parseInt(e.target.id) }],
		};
		var modal = document.getElementById("myModal");
		modal.style.display = "block";
		if (!props.loadRoutes.isLaoded) props.loadRoutes(inputs);
	};

	let itemsType = [];

	if (props.state.loadRoutes.docType)
		props.state.loadRoutes.docType.map((x) => {
			try {
				if (
					props.state.loadRoutes.routes_rules
						.filter((t) => t.requiredDocs.length > 0)
						.map((k) => k.Doc_type_id)
						.includes(x.Doc_type_id)
				) {
					itemsType.push(
						<li
							key={x.Doc_type_id + props.state.auth.user.office[0].office_id}
							id={x.Doc_type_id}
							rel={props.state.auth.user.office[0].office_id}
							className="openmModal"
							onClick={(e) =>
								handleClick(
									e,
									props.state.auth.user.office[0].office_id,
									props.state.auth.user.office[0].office_name,
									false
								)
							}
						>
							<PostAddIcon />
							{x.name +
								" For " +
								props.state.auth.user.office[0].office_name +
								" (Own Office)"}
						</li>
					);
				}
			} catch (e) {
				//console.error("Dashboard litst error=", e);
			}
		});
	try {
		if (props.state.userStatus.actingOfficeHierarchy) {
			props.state.userStatus.status.actingOffice
				.filter((x) => new Date(x.toDate) >= new Date() && !x.cancelled)
				.map((y) => {
					props.state.loadRoutes.docType.map((x) => {
						if (
							props.state.loadRoutes.routes_rules
								.filter((t) => t.requiredDocs.length > 0)
								.map((k) => k.Doc_type_id)
								.includes(x.Doc_type_id)
						) {
							itemsType.push(
								<li
									key={x.Doc_type_id + y.officeActingOnBehalf}
									id={x.Doc_type_id}
									className="openmModal"
									onClick={(e) =>
										handleClick(
											e,
											y.officeActingOnBehalf,
											props.state.auth.user.allOffices.find(
												(z) => z.office_id === y.officeActingOnBehalf
											).office_name,
											true
										)
									}
								>
									<PostAddIcon />
									{x.name +
										"  For " +
										props.state.auth.user.allOffices.find(
											(z) => z.office_id === y.officeActingOnBehalf
										).office_name +
										" (Acting Office)"}
								</li>
							);
						}
					});
				});
		}
	} catch (e) {
		//console.error("Dashboard 1 list error=", e);
	}

	const showDocumentTable = (e) => {
		try {
			var aside = document.querySelector(".side-nav");
			var contents = document.querySelector("#contents");
			aside.classList.add("show-side-nav");
			contents.classList.add("margin");
		} catch (e) {
			console.log("handleClick show-side-navigation1 hide error", e);
		}
		props.resetDocForm();
		let inputs = {
			url: IP.nodeServer + "api/routesRules",
			method: "POST",
			data: [{ name: "Doc_type_id", value: parseInt(1) }],
		};
		props.loadRoutes(inputs);
		if (!props.loadRoutes.isLaoded) props.loadRoutes(inputs);
		let actingOffices = {};
		let assistant_offices=[];


		actingOffices = props.state.userStatus.status.actingOffice
			.filter((x) => new Date(x.toDate) >= new Date() && !x.cancelled)
			.map((x) => x.officeActingOnBehalf);
			try{
		assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id)).map(y=>({office_id:y.office_id}))
		}
		catch(e)
		{}
        console.log("Dashboard real assistant_offices=", assistant_offices);
		console.log("Dashboard real actingOffices=", actingOffices);
		try {
			inputs = {
				url: IP.nodeServer + "api/getDocs",
				method: "POST",
				office_id: state.auth.user.office[0].office_id,
				companyId: state.companyData.selectedCompanyId
					? state.companyData.selectedCompanyId
					: state.auth.user.allCompanies[0]._id,
				actingOffices: actingOffices,
				assistant_offices:assistant_offices,

				page: 1,
				limit: 5,
				action: null,
			};
			console.log("showDocumentTable clicked inputs=", inputs);
			props.getDocsReq(inputs);
		} catch (e) {}

		setShowscreen(<DocProcessingScreen showSearch={true} />);
		var modal = document.getElementById("myModal");
		modal.style.display = "block";

		console.log("showDocumentTable  clicked");
	};
	const showOrganisationChart = (e) => {
		try {
			var aside = document.querySelector(".side-nav");
			var contents = document.querySelector("#contents");
			aside.classList.add("show-side-nav");
			contents.classList.add("margin");
		} catch (e) {
			console.log("handleClick show-side-navigation1 hide error", e);
		}
		var arry = props.state.auth.user.allOffices;
		var allUser = props.state.auth.user.allUser.filter((x) => x.status === 1);
		console.log("arry=", arry);
		let arrayUser = [];
		let arrayUser2 = [];
		let parent = "";

		arry.map((x) => {
			let users = allUser.filter((y) => y.office_id === x.office_id);
			if (x.rep_office) {
				if (allUser.find((y) => y.office_id === x.rep_office))
					parent =
						x.rep_office +
						"#" +
						allUser.find((y) => y.office_id === x.rep_office).username;
				else {
					parent = x.rep_office + "#vacant";
				}
			}
			if (users.length > 0) {
				users.map((z) => {
					let id = x.office_id + "#" + z.username;
					arrayUser.push({
						key: id,
						id: id,
						title: x.office_name,
						name: z.username,
						parent: parent,
					});
				});
			} else {
				let id = x.office_id + "#vacant";
				arrayUser.push({
					key: id,
					id: id,
					title: x.office_name,
					name: "vacant",
					parent: parent,
				});
			}
		});
		arry.map((x) => {
			let users = allUser.filter((y) => y.office_id === x.office_id);
			if (x.rep_office) {
				if (allUser.find((y) => y.office_id === x.rep_office))
					parent =
						x.rep_office +
						"#" +
						allUser.find((y) => y.office_id === x.rep_office).username;
				else {
					parent = x.rep_office + "#vacant";
				}
			}
			if (users.length > 0) {
				users.map((z) => {
					let id = x.office_id + "#" + z.username;
					arrayUser2.push({
						key: id,
						id: id,

						parent: x.rep_office ? parent : null,

						person: {
							id: id,
							avatar:
								"https://s3.amazonaws.com/uifaces/faces/twitter/spbroma/128.jpg",
							department: "",
							name: z.username,
							title: x.office_name,
							totalReports: arry.filter((k) => k.rep_office === id).length,
						},
						hasChild:
							arry.filter((k) => k.rep_office === parseInt(id)).length > 0
								? true
								: false,
						hasParent: x.rep_office ? true : false,
						isHighlight: x.rep_office ? false : true,
					});
				});
			} else {
				let id = x.office_id + "#vacant";
				arrayUser2.push({
					key: id,
					id: id,

					parent: x.rep_office ? parent : null,
					person: {
						id: id,
						avatar:
							"https://s3.amazonaws.com/uifaces/faces/twitter/spbroma/128.jpg",
						department: "",
						name: "vacant",
						title: x.office_name,
						totalReports: arry.filter((k) => k.rep_office === parseInt(id))
							.length,
					},
					hasChild:
						arry.filter((k) => k.rep_office === id).length > 0 ? true : false,
					hasParent: x.rep_office ? true : false,
					isHighlight: x.rep_office ? false : true,
				});
			}
		});
		console.log("arrayUser=", arrayUser);
		console.log("arrayUser2=", arrayUser2);

		function convert(array) {
			console.log("convert array.length", array.length);
			var map = {};
			for (var i = 0; i < array.length; i++) {
				var obj = array[i];
				obj.children = [];

				map[obj.id] = obj;

				var parent = obj.parent || "-";
				if (!map[parent]) {
					map[parent] = {
						children: [],
					};
				}
				map[parent].children.push(obj);
			}

			try {
				return map["-"].children;
			} catch (e) {
				return;
			}
		}

		function convert2(array) {
			console.log("convert array.length", array.length);
			var map = {};
			for (var i = 0; i < array.length; i++) {
				var obj = array[i];
				obj.children = [];

				map[obj.id] = obj;

				var parent = obj.parent || "-";
				if (!map[parent]) {
					map[parent] = {
						children: [],
					};
				}
				map[parent].children.push(obj);
			}

			return map["-"].children;
		}

		var r = convert(arrayUser);
		//var r2 = convert2(arrayUser2);
		console.log("showOrganisationChart r=", r);
		//console.log("showOrganisationChart r2=", r2);
		console.log("showOrganisationChart result=", JSON.stringify(r));
		console.log("showOrganisationChart Clicked");
		setShowscreen(<OrganisationChat data={r} structruredData={arrayUser} />);
		//if (r2.length > 0) setShowscreen(<OrganChart tree={r2} />);
		var modal = document.getElementById("myModal");
		modal.style.display = "block";
	};
	let actingOfficev = {};
	try {
		actingOfficev = store.getState().userStatus.status.actingOffice;
	} catch (e) {}
	const [actingOffice, setActingOffice] = useState(actingOfficev);

	useEffect(() => {
		let content = "";
		if (store.getState().auth) {
			console.log("props.auth=", props.auth);
			var buffer;
			try {
				buffer = Buffer.from(store.getState().auth.user.image.data);
				document.getElementById(
					"username"
				).innerHTML = store
					.getState()
					.auth.user.allUser.find(
						(y) => y._id === store.getState().auth.user.usernameId
					).name;
				setImageSrc("data:image/png;base64," + buffer.toString("base64"));
				setImageAlt(
					store
						.getState()
						.auth.user.allUser.find(
							(y) => y._id === store.getState().auth.user.usernameId
						).username
				);
				content = "-" + store.getState().auth.user.office[0].office_name;
			} catch (e) {
				console.error("Dashboard error=", e);
			}
			//document.getElementById("profilePicture").src ="data:image/png;base64," + buffer.toString("base64");
		}

		if (actingOffice) {
			try {
				console.log(
					"DashBoard store.getState().userStatus.status.actingOffice=",
					store.getState().userStatus.status.actingOffice
				);
				store
					.getState()
					.userStatus.status.actingOffice.filter(
						(x) => new Date(x.toDate) >= new Date() && !x.cancelled
					)
					.map((y) => {
						content +=
							"\r\n - Acting as " +
							store
								.getState()
								.auth.user.allOffices.find(
									(z) => z.office_id === y.officeActingOnBehalf
								).office_name +
							" to " +
							new Date(y.toDate);
					});
			} catch (e) {
				console.error("Dashboard store.getState()=", store.getState());
				console.error("Dashboard error in seting profile office=", e);
			}
		}
		//document.getElementById("office_name").innerHTML = content;
		setOffice_name(content);
	}, [actingOffice]);

	useEffect(() => {
		socket.emit("Notifications");
		refresh();
		if (state.auth.user.office) {
			let actingOffices = {};
			try {
				actingOffices = state.userStatus.actingOfficeHierarchy[0].map(
					(y) => y.office_id
				);
			} catch (e) 
			{}
			let assistant_offices=[];
			try{

			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}
				console.log("state before getDocsAggregates=", state);
			try {
				let inputs = {
					//url: IP.InodeServer+"api/getDocs",
					url: IP.nodeServer + "api/getDocsAggregates",
					method: "POST",
					office_id: parseInt(state.auth.user.office[0].office_id),
					companyId: state.companyData.selectedCompanyId
						? state.companyData.selectedCompanyId
						: state.auth.user.allCompanies[0]._id,
					actingOffices: actingOffices,
					assistant_offices:assistant_offices,
				};
				console.log("getDocsAggregates inputs=", inputs);
				props.getDocs(inputs);
			} catch (e) {}
			console.log("props.state.docs initial=", state.docs);
			/*

			props.getDocsByOffice({
				office_id: props.state.auth.user.office[0].office_id,
			});
			*/
		} else {
			props.logoutUser();
		}

		socket.on("message", (data) => {
			console.log("from socket io on message=", data);
		});
		let inputs = {
			url: IP.nodeServer + "api/routesRules",
			method: "POST",
			data: [{ name: "Doc_type_id", value: parseInt(1) }],
		};
		props.loadRoutes(inputs);

		if (props.state.auth.user.office) {
			let actingOffices = {};
			try {
				actingOffices = props.state.userStatus.actingOfficeHierarchy[0].map(
					(y) => y.office_id
				);
			} catch (e) {}
			let assistant_offices=[];
			try{

			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}
			try {
				props.getDocsReq({
					url: IP.nodeServer + "api/getDocs",
					method: "POST",
					office_id: props.state.auth.user.office[0].office_id,
					companyId: state.companyData.selectedCompanyId
						? state.companyData.selectedCompanyId
						: state.auth.user.allCompanies[0]._id,
					actingOffices: actingOffices,
					assistant_offices:assistant_offices,

					page: 1,
					limit: 5,
					action: null,
				});
			} catch (e) {}
		}

		// Profile photo generation

		// end Profile photo generation
		if (!props.loadRoutes.isLaoded) props.loadRoutes(inputs);
		// Get the modal
		var modal = document.getElementById("myModal");
		// Get the <span> element that closes the modal
		var span = document.getElementsByClassName("close")[0];

		// When the user clicks on <span> (x), close the modal
		/*span.onclick = function () {
			//refresh();
			console.log("span.onclick  get props=", props);

			modal.style.display = "none";
		};
*/
		// When the user clicks anywhere outside of the modal, close it
		window.onclick = function (event) {
			if (event.target === modal) {
				//modal.style.display = "none";
			}
		};

		//if (true) {

		//var buffer = Buffer.from(store.getState().auth.user.image.data);
	}, [showscreen, setShowscreen]);

	console.log("props.state.docs after before=", props.state.docs);

	const openEditing = () => {
		try {
			var aside = document.querySelector(".side-nav");
			var contents = document.querySelector("#contents");
			aside.classList.add("show-side-nav");
			contents.classList.add("margin");
		} catch (e) {
			console.log("handleClick show-side-navigation1 hide error", e);
		}
		props.resetDocForm();
		let inputs = {
			url: IP.nodeServer + "api/routesRules",
			method: "POST",
			data: [{ name: "Doc_type_id", value: parseInt(1) }],
		};
		props.loadRoutes(inputs);
		if (!props.loadRoutes.isLaoded) props.loadRoutes(inputs);

		let actingOffices = {};
		try {
			actingOffices = props.state.userStatus.actingOfficeHierarchy[0].map(
				(y) => y.office_id
			);
		} catch (e) {}
		let assistant_offices=[];
			try{

			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}
		console.log("Dashboard actingOffices=", actingOffices);
		try {
			inputs = {
				url: IP.nodeServer + "api/getDocs",
				method: "POST",
				office_id: props.state.auth.user.office[0].office_id,
				companyId: state.companyData.selectedCompanyId
					? state.companyData.selectedCompanyId
					: state.auth.user.allCompanies[0]._id,
				actingOffices: actingOffices,
				assistant_offices:assistant_offices,
				page: 1,
				limit: 5,
				action: 1,
			};
			console.log("showDocumentTable clicked inputs=", inputs);
			props.getDocsReq(inputs);
		} catch (e) {}

		console.log("openEditing clicked");
		setShowscreen(<DocDraftTabs />);
		var modal = document.getElementById("myModal");
		modal.style.display = "block";

		console.log("showDocumentTable  clicked");
		setShowscreen(<DocDraftTabs />);
		var modal = document.getElementById("myModal");
		modal.style.display = "block";

		console.log("showDocumentTable  clicked");
	};
	const openAllDocs = () => {
		console.log("openAllDocs clicked");
	};
	const showDraftDocs = () => {
		history.push("/document/draft");
	};
	const showTrashDocs = () => {
		history.push("/document/trash");
	};
	const showAllDocs = () => {
		history.push("/document/all");
	};
	useEffect(() => {
		if (state.docs.isDone || state.auth.isAuthenticated) refresh();
		console.log("Dashboard state.docs=", state.docs);
	}, [state.docs.isDone, state.auth.isAuthenticated]);

	return (
		<div className="container">
			<LeftSideScreen
				showAllDocs={showAllDocs}
				showDraftDocs={showDraftDocs}
				showTrashDocs={showTrashDocs}
				openEditing={openEditing}
				openAllDocs={openAllDocs}
				showDocumentTable={showDocumentTable}
				imageSrc={imageSrc}
				imageAlt={imageAlt}
				office_name={office_name}
				username={username}
				setnewProfilePicture={setnewProfilePicture}
			/>

			<section id="contents">
				<PrimarySearchAppBar ref={notitifcationRef} />

				<div className="welcome">
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="content">
									<h2>Welcome to myWork</h2>

									<p>
										This system makes approval process easy due to an automated
										workflow!. Enjoy your work!
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<section className="statistics">
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-4">
								<div className="box" onClick={showDocumentTable}>
									<i className="fa fa-file fa-fw bg-primary"></i>
									<div className="info">
										<h3>{totalDocsv}</h3> <span>Docs</span>
										<p id="totalDocs">Available documents</p>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<Link to="/notification">
									<div className="box">
										<i className="fa fa-envelope fa-fw danger"></i>
										<div className="info">
											<h3>
												<font color="#ccc">
													{state.getNotications.isLoaded
														? state.getNotications.notifications
															? state.getNotications.notifications
																	.NotificationResp
																? state.getNotications.notifications
																		.NotificationResp.total
																: 0
															: 0
														: 0}
												</font>
											</h3>{" "}
											<span>
												<font color="#ccc">Notifications</font>
											</span>
											<p>Total Notifications</p>
										</div>
									</div>
								</Link>
							</div>
							<div className="col-md-4">
								<div className="box" onClick={showOrganisationChart}>
									<i className="fa fa-users fa-fw success"></i>
									<div className="info">
										<h3>{totalUsersv}</h3> <span>Users</span>
										<p>Available Users</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className="statis text-center">
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-3">
								<i className="fa fa-plus"></i>
								<label className="dropdown">
									<div className="dd-button">Document</div>

									<input type="checkbox" className="dd-input" id="test" />

									<ul className="dd-menu">
										<Typography align="left">{itemsType}</Typography>
									</ul>
								</label>
							</div>
						</div>
					</div>
				</section>
			</section>
			<div id="myModal" className="modal">
				<div className="modal-content">
					<span className="close" onClick={handleModelClose}>
						<font color="back">&times;</font>
					</span>
					<section className="statis text-center">
						<div className="container-fluid">
							<div className="row">
								<Box component="div" overflow="hidden" width={1}>
									{showscreen}
								</Box>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	);
}
const mapDispatchToProps = (dispatch) => ({
	loadRoutes: (data) => dispatch(loadRoutes(data)),
	getDocs: (data) => dispatch(getDocs(data)),
	logoutUser: () => dispatch(logoutUser()),
	getDocsByOffice: (data) => dispatch(getDocsByOffice(data)),
	resetDocForm: () => dispatch(resetDocForm()),
	getDocsReq: (data) => dispatch(getDocsReq(data)),
});
const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
